import { Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { api } from "@/api";
import appConfig from "@/config/appConfig";
import DeviceTypeTable from "./DeviceTypeTable";
import { flare } from "@flareapp/js";

const onFinishFailed = (errorInfo) => {
  // eslint-disable-next-line no-console
  console.log("Failed:", errorInfo);
};

const DeviceTypes = () => {
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [deviceTypes, setDeviceTypes] = useState([]);

  const onFinish = async (values) => {
    setIsLoading(true);
    try {
      const response = await api.post(`/device-type`, values);
      if (response) {
        getDeviceTypes();
        await Swal.fire({
          title: "Done!",
          text: "Device Type Created Successfully",
          icon: "success",
          timer: 2000,
          confirmButtonText: "OK",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };
  const getDeviceTypes = async () => {
    try {
      const data = await api.get(`/device-type`);
      if (data) {
        setDeviceTypes(data);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };
  useEffect(() => {
    document.title = `${appConfig.name} - Manage Device Types`;
    getDeviceTypes();
  }, []);

  return (
    <div className="card p-3 m-md-3">
      <label className="az-content-label mt-1">Manage Devices</label>
      <div className="row g-4">
        <div className="col-md-6">
          <span className="d-block py-2">Add Device Type</span>
          <hr className="mt-0" />
          <div className="d-flex justify-content-center">
            {isLoading && <Spinner animation="border" variant="dark" />}
          </div>

          <Form
            layout="vertical"
            name="deviceType"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            form={form}
            size="large"
          >
            <Form.Item
              label="Device Type Name"
              name="name"
              rules={[{ required: true, message: "Device Type Name is required" }]}
            >
              <Input placeholder="Enter Device Type Name" />
            </Form.Item>

            <Form.Item label="Device Type Description" name="description">
              <Input placeholder="Enter Device Type Description" />
            </Form.Item>

            <div className="d-flex justify-content-end gap-3 flex-wrap">
              <button type="submit" className="btn btn-success ">
                Create Device Type
              </button>
              <Link to="/devices" className="btn btn-secondary">
                Cancel
              </Link>
            </div>
          </Form>
        </div>
        <div className="col-md-6">
          <DeviceTypeTable data={deviceTypes} getDeviceTypes={getDeviceTypes} />
        </div>
      </div>
    </div>
  );
};

export default DeviceTypes;
